import React from 'react';
import './Modal.css';

interface UpgradeDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  total: number;
  lines: Array<{
    amount: number;
    description: string;
  }>;
  tracking?: {
    rru: number;
    wru: number;
  };
  period?: {
    start: number;
    end: number;
  };
}

const UpgradeDetailsModal: React.FC<UpgradeDetailsModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  total,
  lines,
  tracking,
  period
}) => {
  if (!isOpen) return null;

  const formatAmount = (amount: number) => {
    const formatted = (Math.abs(amount) / 100).toFixed(2);
    return amount < 0 ? `-$${formatted}` : `+$${formatted}`;
  };

  const formatTotal = (total: number) => {
    return (total / 100).toFixed(2);
  };

  return (
    <div className="modal open">
      <div className="modal-content" style={{width: '400px', textAlign: 'left', color: 'var(--dialog-color)', backgroundColor: 'var(--dialog-background-color)'}}>
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <div>
            {total >= 0 
              ? <>You will be charged <span style={{fontWeight: 'bold'}}>${formatTotal(total)}</span> for this immediate upgrade.</>
              : <>You will be credited <span style={{fontWeight: 'bold'}}>${formatTotal(Math.abs(total))}</span> to your account which will be used to make future payments.</>
            }
          </div>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <div style={{ border: '1px solid var(--border-color)', borderRadius: '4px', padding: '10px', backgroundColor: 'var(--panel-background-color)', color: 'var(--panel-color)' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                {lines.map((line, index) => (
                  <tr key={index}>
                    <td style={{ 
                      padding: '8px 20px 8px 0',
                      borderBottom: '1px solid var(--border-color)',
                      verticalAlign: 'top'
                    }}>
                      {line.description}
                    </td>
                    <td style={{ 
                      padding: '8px 0 8px 20px',
                      textAlign: 'right',
                      borderBottom: '1px solid var(--border-color)',
                      verticalAlign: 'top'
                    }}>
                      {formatAmount(line.amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              marginTop: '10px'
            }}>
              <span style={{ padding: '8px 20px 8px 0', fontWeight: 'bold' }}>Total</span>
              <span style={{ textAlign: 'right', padding: '8px 0 8px 20px', fontWeight: 'bold' }}>
                {total < 0 ? `-$${(Math.abs(total) / 100).toFixed(2)}` : `$${(total / 100).toFixed(2)}`}
              </span>
            </div>
          </div>
        </div>

        {period && (
          <div style={{ marginBottom: '20px', textAlign: 'center' }}>
            <div>
              Your next payment after this will be due {new Date(period.end * 1000).toLocaleDateString()}.
            </div>
          </div>
        )}

        {tracking && (
          <div style={{ marginBottom: '20px', fontSize: '12px', color: 'var(--subtext-color)', textAlign: 'center' }}>
            <div>Recurring Revenue Units: {tracking.rru}</div>
            <div>Web Revenue Units: {tracking.wru}</div>
          </div>
        )}
        
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '10px'}}>
          <button onClick={onClose}>Cancel</button>
          <button onClick={onConfirm}>Confirm Upgrade</button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeDetailsModal;
